import { useEffect, useState } from "react";
import { updateAllNotes } from "../../store/knownDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { DataContainer } from "../../components/DataContainer";
import TextareaAutosize from 'react-textarea-autosize';
import { toast } from "react-toastify";



function AllNotes({ id, showClientNotes = true, showLogisticsNotes = true, showDriverNotes = true }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);
    const user = useSelector((state) => state.user.data);

    const [clientNotes, setClientNotes] = useState("");
    const [logisticsNotes, setLogisticsNotes] = useState("");
    const [driverNotes, setDriverNotes] = useState("");

    async function onUpdate() {
        await dispatch(updateAllNotes({
            id,
            client_notes: clientNotes,
            logistics_notes: logisticsNotes,
            driver_notes: driverNotes
        }));
        toast.success("Kõik märkmed salvestatud!");
    }

    useEffect(() => {
        if(data) {
            setClientNotes(data["query_notes"] || "");
            setLogisticsNotes(data["query_response_logistics_notes"] || "");
            setDriverNotes(data["query_driver_notes"] || "");
        }
    }, [data]);

    const visibleNotesCount = [showClientNotes, showLogisticsNotes, showDriverNotes].filter(Boolean).length;
    const saveButtonText = visibleNotesCount === 1 ? "Salvesta" : "Salvesta kõik märkmed";

    return (<>
        <hr />

        <DataContainer actionType={"knownData/updateAllNotes"}>
            <div className="column g32">
                <h2>Märkmed</h2>

                {showClientNotes && (
                    <div className="column g8">
                        <h3>Kliendi lisainfo</h3>
                        {(data["query_response_status"] === "accepted" || data["job_id"]) ? (
                            <p>(Kasutada kui soovid edastada kliendile lisainfot töö kohta)</p>
                        ) : <></>}
                        <div className="column g4">
                            <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Kliendi lisainfo' value={clientNotes} onChange={(e) => setClientNotes(e.target.value)} />
                            <i style={{ color: '#888', fontSize: 14 }}>Vajuta Enter-it, et uuele reale minna</i>
                        </div>
                    </div>
                )}

                {showLogisticsNotes && (
                    <div className="column g4">
                        <h3>"Pane tähele" tekst</h3>
                        <div className="column g4">
                            <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='"Pane tähele" tekst' value={logisticsNotes} onChange={(e) => setLogisticsNotes(e.target.value)} />
                            <i style={{ color: '#888', fontSize: 14 }}>Vajuta Enter-it, et uuele reale minna</i>
                        </div>
                    </div>
                )}

                {showDriverNotes && (
                    <div className="column g4">
                        <h3>Märkmed juhile</h3>
                        <div className="column g4">
                            <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Märkmed juhile' value={driverNotes} onChange={(e) => setDriverNotes(e.target.value)} />
                            <i style={{ color: '#888', fontSize: 14 }}>Vajuta Enter-it, et uuele reale minna</i>
                        </div>
                    </div>
                )}

                <button onClick={onUpdate}>{saveButtonText}</button>
            </div>
        </DataContainer>
    </>);
};

export default AllNotes;